import { render, staticRenderFns } from "./UserFormInsurance.vue?vue&type=template&id=b61a822a&scoped=true&"
import script from "./UserFormInsurance.vue?vue&type=script&lang=js&"
export * from "./UserFormInsurance.vue?vue&type=script&lang=js&"
import style0 from "./UserFormInsurance.vue?vue&type=style&index=0&id=b61a822a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61a822a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b61a822a')) {
      api.createRecord('b61a822a', component.options)
    } else {
      api.reload('b61a822a', component.options)
    }
    module.hot.accept("./UserFormInsurance.vue?vue&type=template&id=b61a822a&scoped=true&", function () {
      api.rerender('b61a822a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserFormInsurance.vue"
export default component.exports